// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles and box-sizing */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Roboto', Arial, sans-serif;
}

/* Main container */
.invoice-app {
  background: #fafafa;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
}

/* TopBar Styles */
.top-bar {
  display: flex;
  width: 100%;
}

.top-bar-content {
  background: #5f5791;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.logo-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 260px;
}

.top-bar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
}

.app-name {
  color: #fdf8ff;
  text-align: left;
  font-size: 18px;
  line-height: 14px;
  letter-spacing: 0.1px;
  font-weight: 700;
  font-style: italic;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-primary {
  color: #c9bfff;
}

.icon-onprimary {
  color: #ffffff;
}

.icon-secondary {
  color: #484459;
}

.icon-grey {
  color: #808080;
}

.icon-lightgrey {
  color: #b3b3b3;
}

.icon-blue {
  color: #006acc;
}

.icon-small {
  font-size: 18px;
}

.icon-medium {
  font-size: 25px;
}

.icon-light {
  font-weight: 200;
}

/* Tabs Styles */
.tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}

.tab {
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}

.tab-selected {
  background: #c9bfff;
}

.tab-label {
  color: #ffffff;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tab-label-selected {
  color: #312f36;
}

.vertical-divider {
  width: 1px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.3);
}

/* Language and User Actions */
.actions-container {
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.language-selector {
  background: #ffffff;
  border-radius: 4px;
  padding: 8px 8px 8px 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
}

.language-text {
  color: #484459;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
    font-weight: 400;
}

.user-avatar {
  background: #e5deff;
  border-radius: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;
}

.avatar-text {
  color: #473f77;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  font-weight: 400;
}

.avatar-image {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
}

/* Main Content Container */
.content-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  height: calc(100vh - 60px); /* 减去TopBar的高度 */
  overflow: hidden;
}

/* Sidebar Styles */
.sidebar {
  background: #ffffff;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 260px;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.sidebar-title {
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.sidebar-title-text {
  color: #48454e;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 500;
  text-transform: uppercase;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.menu-item {
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  height: 40px;
  cursor: pointer;
}

.menu-item-active {
  background: rgba(95, 87, 145, 0.12);
  border-left: 2px solid #ff8b06;
}

.menu-item-label {
  color: #1c1b20;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 600;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-item-badge {
  color: #1c1b20;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 600;
}

/* Main Content Area - 这里是关键的滚动容器 */
.main-content {
  padding: 24px 24px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow-y: auto; /* 启用垂直滚动 */
  overflow-x: hidden;
  height: calc(100vh - 64px); /* 确保有明确的高度 */
}

/* Action Bar */
.action-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.action-group {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}

.action-button {
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #cccccc;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: center;
  height: 40px;
  cursor: pointer;
}

.action-button-icon-only {
  width: 40px;
}

.action-button-blue {
  background: #ffffff;
  border-color: #006acc;
}

.action-button-text {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-button-text-blue {
  color: #006acc;
}

/* Invoice Table */
.invoice-table {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.table-header {
  background: #e5dff9;
  display: flex;
  width: 100%;
}

.table-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.table-body-row {
  background: #ffffff;
  border-bottom: 1px solid #c9c5d0;
}

.table-body-row-alternate {
  background: #f5f5f5;
  border-bottom: 1px solid #c9c5d0;
}

/* .cell-header-text {
  color: #1c1b20;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  font-weight: 500;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
} */

.cell-text {
  color: #4d4d4d;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  font-weight: 400;
  width: 100%;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.cell-link {
  color: #0000ee;
  text-decoration: underline;
}

.cell-empty {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-weight: 400;
}

/* Filter Row */
.filter-row {
  background: #ffffff;
  border-bottom: 1px solid #c9c5d0;
  height: 50px;
  display: flex;
  position: sticky;
  top: 40px; /* 紧贴在custom-table-header下方 */
  z-index: 99;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.filter-cell {
  flex:100
}

.filter-input {
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #c9c5d0;
  padding: 0 8px;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
}

.filter-input-active {
  background: #ffffff;
}

.filter-input-text {
  color: #4d4d4d;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  font-weight: 400;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Status Chips */
.status-chip {
  border-radius: 4px;
  border: 1px solid;
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  height: 26px;
  white-space: nowrap;
}

.status-chip-text {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  font-weight: 400;
  text-transform: uppercase;
}

.status-submitted {
  background: #e5ffe5;
  border-color: #006400;
}

.status-submitted-text {
  color: #006400;
}

.status-pending {
  background: #ffffe0;
  border-color: #b6a32f;
}

.status-pending-text {
  color: #b6a32f;
}

.status-error {
  background: #d32f2f;
  border-color: #d32f2f;
}

.status-error-text {
  color: #ffffff;
}

.status-red-note {
  background: #ffdad6;
  border-color: #93000a;
}

.status-red-note-text {
  color: #93000a;
}

.pdf-chip {
  background: #e5f3ff;
  border-radius: 4px;
  border: 1px solid #006acc;
  /* padding: 0 12px 0 8px; */
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  justify-content: center;
  height: 26px;
}

.pdf-chip-text {
  color: #006acc;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  font-weight: 400;
}

/* 实现sticky吸顶 - 相对于main-content滚动容器 */
.custom-table-header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: -24px;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.custom-table-header .table-row {
  display: flex;
  width: 100%;
}

.custom-table-header .header-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  flex:100;
  min-width: 0;
}

.custom-table-header .cell-header-text {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-size: 14px;
  padding: 16px 8px;
  width: 100%;

  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  /* width: 100%; */
}

.icon-error {
  color: white !important;
  opacity: 0.7;
}

/* Popover */
`, "",{"version":3,"sources":["webpack://./src/styles/EInvoice.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;IACnB,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,0BAA0B,EAAE,gBAAgB;EAC5C,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,6EAA6E;EAC7E,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB,EAAE,WAAW;EAC7B,kBAAkB;EAClB,0BAA0B,EAAE,aAAa;AAC3C;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX;;4BAE0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,SAAS,EAAE,6BAA6B;EACxC,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;;EAEX;;wBAEsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,YAAY","sourcesContent":["/* Global styles and box-sizing */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Roboto', Arial, sans-serif;\n}\n\n/* Main container */\n.invoice-app {\n  background: #fafafa;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* TopBar Styles */\n.top-bar {\n  display: flex;\n  width: 100%;\n}\n\n.top-bar-content {\n  background: #5f5791;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.logo-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: 260px;\n}\n\n.top-bar-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n}\n\n.app-name {\n  color: #fdf8ff;\n  text-align: left;\n  font-size: 18px;\n  line-height: 14px;\n  letter-spacing: 0.1px;\n  font-weight: 700;\n  font-style: italic;\n}\n\n.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-primary {\n  color: #c9bfff;\n}\n\n.icon-onprimary {\n  color: #ffffff;\n}\n\n.icon-secondary {\n  color: #484459;\n}\n\n.icon-grey {\n  color: #808080;\n}\n\n.icon-lightgrey {\n  color: #b3b3b3;\n}\n\n.icon-blue {\n  color: #006acc;\n}\n\n.icon-small {\n  font-size: 18px;\n}\n\n.icon-medium {\n  font-size: 25px;\n}\n\n.icon-light {\n  font-weight: 200;\n}\n\n/* Tabs Styles */\n.tabs {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n}\n\n.tab {\n  padding: 8px 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n}\n\n.tab-selected {\n  background: #c9bfff;\n}\n\n.tab-label {\n  color: #ffffff;\n  text-align: left;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tab-label-selected {\n  color: #312f36;\n}\n\n.vertical-divider {\n  width: 1px;\n  height: 32px;\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n/* Language and User Actions */\n.actions-container {\n  padding: 0 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 1;\n}\n\n.language-selector {\n  background: #ffffff;\n  border-radius: 4px;\n  padding: 8px 8px 8px 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-start;\n  height: 40px;\n}\n\n.language-text {\n  color: #484459;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n    font-weight: 400;\n}\n\n.user-avatar {\n  background: #e5deff;\n  border-radius: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.avatar-text {\n  color: #473f77;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  font-weight: 400;\n}\n\n.avatar-image {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  object-fit: cover;\n}\n\n/* Main Content Container */\n.content-container {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  height: calc(100vh - 60px); /* 减去TopBar的高度 */\n  overflow: hidden;\n}\n\n/* Sidebar Styles */\n.sidebar {\n  background: #ffffff;\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 260px;\n  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.3);\n  z-index: 1;\n}\n\n.sidebar-title {\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar-title-text {\n  color: #48454e;\n  text-align: center;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.sidebar-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.menu-item {\n  padding: 8px 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  height: 40px;\n  cursor: pointer;\n}\n\n.menu-item-active {\n  background: rgba(95, 87, 145, 0.12);\n  border-left: 2px solid #ff8b06;\n}\n\n.menu-item-label {\n  color: #1c1b20;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 600;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.menu-item-badge {\n  color: #1c1b20;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 600;\n}\n\n/* Main Content Area - 这里是关键的滚动容器 */\n.main-content {\n  padding: 24px 24px 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  overflow-y: auto; /* 启用垂直滚动 */\n  overflow-x: hidden;\n  height: calc(100vh - 64px); /* 确保有明确的高度 */\n}\n\n/* Action Bar */\n.action-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.action-group {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n}\n\n.action-button {\n  background: #fafafa;\n  border-radius: 4px;\n  border: 1px solid #cccccc;\n  padding: 0 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  cursor: pointer;\n}\n\n.action-button-icon-only {\n  width: 40px;\n}\n\n.action-button-blue {\n  background: #ffffff;\n  border-color: #006acc;\n}\n\n.action-button-text {\n  color: #b3b3b3;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.action-button-text-blue {\n  color: #006acc;\n}\n\n/* Invoice Table */\n.invoice-table {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.table-header {\n  background: #e5dff9;\n  display: flex;\n  width: 100%;\n}\n\n.table-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n}\n\n.table-body-row {\n  background: #ffffff;\n  border-bottom: 1px solid #c9c5d0;\n}\n\n.table-body-row-alternate {\n  background: #f5f5f5;\n  border-bottom: 1px solid #c9c5d0;\n}\n\n/* .cell-header-text {\n  color: #1c1b20;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  font-weight: 500;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n} */\n\n.cell-text {\n  color: #4d4d4d;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  font-weight: 400;\n  width: 100%;\n  /* white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; */\n}\n\n.cell-link {\n  color: #0000ee;\n  text-decoration: underline;\n}\n\n.cell-empty {\n  color: #b3b3b3;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  font-weight: 400;\n}\n\n/* Filter Row */\n.filter-row {\n  background: #ffffff;\n  border-bottom: 1px solid #c9c5d0;\n  height: 50px;\n  display: flex;\n  position: sticky;\n  top: 40px; /* 紧贴在custom-table-header下方 */\n  z-index: 99;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.filter-cell {\n  flex:100\n}\n\n.filter-input {\n  background: #fafafa;\n  border-radius: 4px;\n  border: 1px solid #c9c5d0;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.filter-input-active {\n  background: #ffffff;\n}\n\n.filter-input-text {\n  color: #4d4d4d;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  font-weight: 400;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Status Chips */\n.status-chip {\n  border-radius: 4px;\n  border: 1px solid;\n  padding: 0 12px;\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  height: 26px;\n  white-space: nowrap;\n}\n\n.status-chip-text {\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n\n.status-submitted {\n  background: #e5ffe5;\n  border-color: #006400;\n}\n\n.status-submitted-text {\n  color: #006400;\n}\n\n.status-pending {\n  background: #ffffe0;\n  border-color: #b6a32f;\n}\n\n.status-pending-text {\n  color: #b6a32f;\n}\n\n.status-error {\n  background: #d32f2f;\n  border-color: #d32f2f;\n}\n\n.status-error-text {\n  color: #ffffff;\n}\n\n.status-red-note {\n  background: #ffdad6;\n  border-color: #93000a;\n}\n\n.status-red-note-text {\n  color: #93000a;\n}\n\n.pdf-chip {\n  background: #e5f3ff;\n  border-radius: 4px;\n  border: 1px solid #006acc;\n  /* padding: 0 12px 0 8px; */\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  height: 26px;\n}\n\n.pdf-chip-text {\n  color: #006acc;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  font-weight: 400;\n}\n\n/* 实现sticky吸顶 - 相对于main-content滚动容器 */\n.custom-table-header {\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #e8e8e8;\n  position: sticky;\n  top: -24px;\n  z-index: 100;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.custom-table-header .table-row {\n  display: flex;\n  width: 100%;\n}\n\n.custom-table-header .header-cell {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  flex:100;\n  min-width: 0;\n}\n\n.custom-table-header .cell-header-text {\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n  text-align: left;\n  font-size: 14px;\n  padding: 16px 8px;\n  width: 100%;\n\n  /* overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; */\n  /* width: 100%; */\n}\n\n.icon-error {\n  color: white !important;\n  opacity: 0.7;\n}\n\n/* Popover */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
